import styled from 'styled-components';
import PriceSuggest from './PriceSuggest';
import { SUGGESTION_TYPES } from 'state/direct-order/suggested-quotes/constants';

export default styled(PriceSuggest)`
  .price-suggest {
    &__suggestion {
      width: 100%;
      min-width: 200px;
      margin-top: 2.4rem;
      border-radius: 4px;
      border: 1px solid var(--primary500);
      padding: 0.8rem 1.6rem;
      background-color: var(--white);
      cursor: pointer;

      &-${SUGGESTION_TYPES.TODAY} {
        .tag {
          background-color: var(--success100);
          color: var(--success900);
        }
      }
      &-${SUGGESTION_TYPES.DIRECT} {
        .tag {
          background-color: var(--primary100);
          color: var(--primary900);
        }
      }
      &-${'ECONOMY'} {
        .tag {
          background-color: var(--deep-purple300);
          color: var(--deep-purple500);
        }
      }
      &-${SUGGESTION_TYPES.TWENTY_FOUR_HOUR} {
        .tag {
          background-color: var(--deep-purple100);
          color: var(--deep-purple900);
        }
      }

      &-header {
        margin-top: 0.6rem;
        margin-bottom: 1.6rem;
        display: flex;

        .tag {
          text-transform: initial;
          margin-left: 0.4rem;
          font-size: 1.6rem;
        }
      }
      &-title {
        font-weight: 500;
        color: var(--primary900);
      }
      &-concept {
        color: var(--grey900);
        margin-bottom: 2.4rem;
        span {
          text-transform: lowercase;
          font-weight: 500;
          margin-left: 0.4rem;
        }
      }
      &-price {
        color: var(--primary900);
        font-weight: 500;
        font-size: 1.8rem;
        flex-grow: 1;
        text-align: right;
      }

      &-btn {
        padding-left: 0;
      }
      &-btn-ECONOMY {
        .btnWrapper {
          justify-content: start;
        }
        .btnWrapper span {
          text-decoration: underline;
        }
      }
      .text-align-left {
        text-align: left;
      }
    }
  }
`;
